const CryptoJS = require('./cryptojs');  //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("b7ilNqjgFYU86faW");  //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('Uiw1BOpujTfVMShn');   //十六位十六进制数作为密钥偏移量

//加密
function encrypted(param) {
  var encrypted = CryptoJS.AES.encrypt(param, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
  return encrypted.toString();
}

//解密
function decrypted(param) {
  // param = CryptoJS.enc.Base64.parse(param)
  var decrypted = CryptoJS.AES.decrypt(param, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7  });
  return CryptoJS.enc.Utf8.stringify(decrypted);
}

// function Encrypt(data) {
//   var key = CryptoJS.enc.Utf8.parse("2dcac286637c9149");
//   var iv = CryptoJS.enc.Utf8.parse("642ccf7a8e72dffa");
//   var encrypted = CryptoJS.AES.encrypt(data, key, {
//       iv: iv,
//       mode: CryptoJS.mode.ECB,
//       padding: CryptoJS.pad.Pkcs7
//   });
//   //返回的是base64格式的密文
//   return encrypted.ciphertext.toString();
// }
// // 解密方法
// // encrypted 为是base64格式的密文
// function Decrypt(encrypted) {
//   // 拿到字符串类型的密文需要先将其用Hex方法parse一下
//   var encryptedHexStr = CryptoJS.enc.Hex.parse(encrypted);
//   // 将密文转为Base64的字符串
//   // 只有Base64类型的字符串密文才能对其进行解密
//   var encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
//   var key = CryptoJS.enc.Utf8.parse("2dcac286637c9149");
//   var iv = CryptoJS.enc.Utf8.parse("642ccf7a8e72dffa");
//   var decrypt = CryptoJS.AES.decrypt(encryptedBase64Str, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
//   return CryptoJS.enc.Utf8.stringify(decrypt)
// }

// //解密
// function decrypValue (value) {
//   var keyHex = CryptoJS.enc.Base64.parse("2dcac286637c9149");
//   var ivHex = CryptoJS.enc.Base64.parse("642ccf7a8e72dffa");
//   var decrypted = CryptoJS.DES.decrypt({
//     ciphertext: CryptoJS.enc.Base64.parse(value)
//   }, keyHex, {
//     iv:ivHex,
//     mode: CryptoJS.mode.CBC,
//     padding:CryptoJS.pad.Pkcs7
//   });
//   return decrypted.toString(CryptoJS.enc.Utf8);
// };
// //加密
// function encrypValue (value) {
//   var keyHex = CryptoJS.enc.Base64.parse("2dcac286637c9149");
//   var ivHex = CryptoJS.enc.Base64.parse("642ccf7a8e72dffa");
//   var encrypted = CryptoJS.DES.encrypt(value, keyHex, {
//     iv:ivHex,
//     mode: CryptoJS.mode.CBC,
//     padding:CryptoJS.pad.Pkcs7
//   });
//   return encrypted.toString();
// }

module.exports = {
  encrypted: encrypted,
  decrypted: decrypted,
  // Encrypt:Encrypt,
  // Decrypt:Decrypt,
  // encrypValue:encrypValue,
  // decrypValue:decrypValue,

}